<template>
  <v-container
    fluid
    fill-width
    class="ma-0 pa-0"
    center="start"
    justify="start"
  >
    <v-row class="pa-0 ma-0">
      <v-col cols="12" class="pa-0 ma-0">
        <v-container
          fluid
          fill-width
          class="ma-0 pa-2"
          center="start"
          justify="start"
        >
          <v-app-bar app class="primary">
            <v-icon color="white" x-large>mdi-upload</v-icon>
            <v-toolbar-title class="white--text pl-3"
              >Data Upload
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-app-bar>

          <v-sheet
            color="white"
            class="scroll rounded-lg shadow my-2 pa-0 pb-2"
          >
            <v-container fluid fill-width class="ma-0 pa-0">
              <v-row class="ma-0 pa-0">
                <v-col cols="12" class="ma-0 pa-0">
                  <v-card color="#eeeeee" class="pt-1">
                    <v-card-title class="primary--text pl-3 py-1"
                      >UPLOAD FILE
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>

            <v-container fluid fill-width>
              <v-row class="pt-3">
                <v-col cols="8">
                  <v-file-input
                    v-model="file"
                    prepend-icon="mdi-file-upload"
                    show-size
                    label="Choose file to upload"
                    :truncate-length="100"
                    dense
                  ></v-file-input>
                </v-col>
                <v-col cols="4">
                  <v-btn :disabled="file == null" @click="uploadFile"
                    >UPLOAD FILE</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-sheet>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'DataUpload',
  components: {},
  props: {},
  data() {
    return {
      file: null,
    };
  },
  computed: {},
  watch: {},
  async created() {},
  methods: {
    uploadFile() {
      const formData = new FormData();
      formData.append('file', this.file);
      const headers = { 'Content-Type': 'multipart/form-data' };
      axios.post('/api/upload_file', formData, { headers });
    },
  },
};
</script>

<style scoped></style>
